<template>
  <div class="sidebar-menu-item m-0 mt-1" :class="{'active': active}" v-on="$listeners">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['active']
}
</script>
<style scoped lang="scss">
.sidebar-menu-item {
  cursor: pointer;
  font-weight: 400;
  border-radius: $border-radius;
}
.sidebar-menu-item:hover {
  background-color: $gray-300 !important;
}
.active {
  color: $primary !important;
  font-weight: 600;
}
</style>
